module.exports = __webpack_public_path__ + "img/community_challenge_complete.c0882953.svg";